

// Import ----------------------------------------------------------------------

// Nuxt / Vendor
import mixins from "vue-typed-mixins";

// Project
import NavBar from "~/components/NavBar.vue";
import FooterBar from "~/components/FooterBar.vue";
import WindowScrollPosition from "~/mixins/WindowScrollPosition";

// Export ----------------------------------------------------------------------

export default mixins(WindowScrollPosition).extend({

    // Component imports -------------------------------------------------------

    components: {
        NavBar,
        FooterBar
    },

    // Component Internal Data State -------------------------------------------

    data: () => ({
        scrollThreshold: false
    }),

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    props: {
        layout: {
            type: String,
            required: false,
            default: "default"
        },

        headerStyles: {
            type: Object,
            required: false,
            default: () => {}
        }
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        classes (): string[] {
            const classes = ["layout", "layout-" + this.layout];

            if (this.hasReachedScrolThreshold) {
                classes.push("header-scrolled");
            }

            return classes;
        },

        /**
         * When scrolling calculate when we more than 150px down the Y.
         *
         * To prevent when the scoll point is at exact the threshold bounching
         * between transition we define greater than and less than seperately.
         */
        hasReachedScrolThreshold (): boolean {
            if (this.scrollPosition.y < 150) {
                return false;
            }

            if (this.scrollPosition.y > 155) {
                return true;
            }

            return false;
        }
    }

    // -------------------------------------------------------------------------
});
